<template>
  <div id="enterprise-camera-list">
    <vs-alert
      color="warning"
      class="mt-5"
      icon-pack="feather"
      icon="icon-info"
      :active.sync="noCameras"
    >
      <span>登録されているカメラはありません</span>
    </vs-alert>

    <div class="relative"  style="top: -48px; right: 0; max-height: 0;" >
      <div class="flex items-start justify-end flex-wrap" style="padding: 0.8rem 0.2rem;">
        <div class="flex items-center rounded" style="height: 30px;">
          <div :class="{ 'grid-button-selected': gridLayout === 1, 'grid-button-unselected': gridLayout !== 1, }" style="border: 2px solid #48A0F4; border-radius: 4px 0 0 4px;">
            <vs-tooltip class="test-test" text="カメラ一覧" position="bottom" >
              <vs-dropdown
                class="cursor-pointer" vs-trigger-click
              >
              <div id="grid-button-iconGrid1" class="flex h-full justify-center items-center grid-button-icon" />

                <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(1,4)">
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout14" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">４列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(1,3)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout13" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(1,2)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout12" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
          <div :class="{ 'grid-button-selected': gridLayout === 2, 'grid-button-unselected': gridLayout !== 2, }" style="border-top: 2px solid #48A0F4; border-bottom: 2px solid #48A0F4;">
            <vs-tooltip text="カメラ＋マップ" position="bottom" >
              <vs-dropdown
                class="cursor-pointer" vs-trigger-click
              >
                <div id="grid-button-iconGrid2" class="flex h-full justify-center items-center grid-button-icon" />

                <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(2,3)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout23" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(2,2)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout22" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(2,1)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout21" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">１列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
          <div :class="{ 'grid-button-selected': gridLayout === 3, 'grid-button-unselected': gridLayout !== 3,  }" style="border: 2px solid #48A0F4; border-radius: 0 4px 4px 0;">
            <vs-tooltip text="カメラ＋マップ＋ピックアップ" position="bottom" >
              <vs-dropdown
                class="cursor-pointer" vs-trigger-click
              >
                <div id="grid-button-iconGrid3" class="flex h-full justify-center items-center grid-button-icon" />

                 <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(3,3)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout33" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(3,2)" >
                    <div class="camera-list-layout-dropdown-item flex items-center">
                      <span class="flex items-center" :style="{ 'color': AISEA_COLOR.BLACK }">
                        <img :src="iconGridLayout32" style="width: 24px; height: 24px;" />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
        </div>

        <vs-tooltip text="表示設定" position="bottom" >
          <div class="flex items-center justify-center filter-button cursor-pointer" @click="isFilterSidebarActive = !isFilterSidebarActive">
            <span class="filter-icon material-icons" style="transform:rotate(90deg);">tune</span>
          </div>
        </vs-tooltip>

        <vs-tooltip text="カメラリスト" position="bottom" >
          <div class="flex items-center justify-center sort-button" @click="$router.push({ name: 'enterprise-management-camera-sort' })">
            <span class="sort-icon material-icons" >list</span>
          </div>
        </vs-tooltip>

      </div>
    </div>

    <div v-if="!noCameras">
      <div id="camera-content-container" class="relative clearfix flex items-start justify-between">
        <div class="h-full" :style="gridLayoutStyle('leftBlock')"  >
          <!-- マップエリア -->
          <div id="map-on-camera-parent" class="relative w-full" :style="gridLayoutStyle('mapBlock')" >
            <div id="map-on-camera-list" class="w-full h-full" />
            <div 
              class="flex justify-center items-center"
              style="flex-direction: column; position: absolute; bottom: 20px; right: 10px; "
            >
              <div 
                class="flex justify-center items-center mt-1 rounded cursor-pointer"
                style="width: 29px; height: 29px; background-color: white; z-index: 9;"
                @click="initMapPosition"
              >
                <span class="material-icons" style="color: #333333;">zoom_out_map</span>
              </div>
              <div 
                class="flex justify-center items-center mt-1 rounded cursor-pointer"
                style="width: 29px; height: 29px; background-color: white; z-index: 9;"
                @click="resetMapPosition"
              >
                <span class="material-icons" style="color: #333333;">home</span>
              </div>
            </div>

            <div 
              class="flex justify-center items-center"
              style="flex-direction: column; position: absolute; bottom: 20px; left: 10px; "
            >
              <div 
                class="flex justify-center items-center m-0 cursor-pointer"
                style="width: 29px; height: 29px; background-color: white; z-index: 9; border-radius: 0.25rem 0.25rem 0 0;"
                @click="mapZoomIn"
              >
                <svg width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='#333'>
                  <path d='M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5z'/>
                </svg>
              </div>
              <div 
                class="flex justify-center items-center m-0 cursor-pointer"
                style="width: 29px; height: 29px; background-color: white; z-index: 9; border-top: 1px solid #dddddd; border-bottom: 1px solid #dddddd; "
                @click="mapZoomOut"
              >
                <svg width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='#333'>
                  <path d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-9z'/>
                </svg>
              </div>
              <div 
                class="flex justify-center items-center m-0 cursor-pointer"
                style="width: 29px; height: 29px; background-color: white; z-index: 9; border-radius: 0 0 0.25rem 0.25rem;"
                @click="mapNorthUp"
              >
                <svg  :style="{'transform': `rotate(${ mapRotateDeg }deg)`}" width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='#333'>
                  <path d='M10.5 14l4-8 4 8h-8z'/>
                  <path id='south' d='M10.5 16l4 8 4-8h-8z' fill='#ccc'/>
                </svg>
              </div>
            </div>

          </div>

        </div>
        <!-- カメラエリア -->
        <div :style="gridLayoutStyle('rightBlock')" style="margin-right: 12px;" >

          <!-- クローズアップカメラエリア -->
          <div id="close-up-camera-area" class="vs-con-loading__container" :style="gridLayoutStyle('closeUpCameraBlock')" style="position: relative;" >
            <live-camera-grid-view
              v-if="closeUpCamera"
              ref="closeUpCameraGrid"
              :camera="closeUpCamera"
              :dispCameras = "dispCameras"
              :forcePlayFlg="closeUpCameraForcePlayFlg"
              :isCloseUpCamera="true"
              :gridHeight="'calc(( 50vh - 60px - 40px ))'"
              @onSelectCamera="onSelectCamera($event)"
            />
          </div>

          <!-- Liveカメラ(小) -->
          <div v-if="cameras.length !== 0" class="vs-row"  :style="gridLayoutStyle('cameraListBlock')" >
            <div
              class="vs-col w-full relative"
              :style="{ 'width': gridWidth, }"
              style="margin: 0 0 8px 8px;"
              v-for="(camera) in dispCameras"
              v-show="camera.isShow"
              :key="camera.id"
              :id="camera.id"
            >
                <live-camera-grid-view 
                  :camera="camera"
                  :dispCameras = "dispCameras"
                  :gridLayout="gridLayout"
                  :gridColNum="gridColNum"
                  :gridHeight="gridHeight"
                  @onSelectCamera="onSelectCamera($event)"
                />
                <div 
                  class="w-full h-full rounded"
                  :style="{ 'border': (closeUpCamera && closeUpCamera.id === camera.id && gridLayout !== 1) ? '4px solid #48A0F4' : null }"
                  style="position: absolute; top: 0; left: 0; z-index: 99; pointer-events: none;" 
                />
            </div>
          </div>
        </div>

      </div>

      <!-- サイドメニューエリア -->
      <vs-sidebar
        class="items-no-padding background-absolute"
        position-right
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isFilterSidebarActive"
      >
        <div class="p-6 filter-container h-full filter-sidebar-background overflow-y-auto">    
          <div class="flex items-center justify-between">
            <div class="flex justify-start items-start" >
              <h6 class="font-bold mb-3 filter-sidebar-font-color ml-1">表示設定</h6>
            </div>
            <feather-icon
              icon="XIcon"
              svgClasses="h-7 w-7"
              class="filter-sidebar-font-color"
              @click="isFilterSidebarActive = !isFilterSidebarActive"
            />
          </div>
          <vs-divider class="filter-sidebar-divide-color" />

          <div v-if="vesselsName && vesselsName.length > 0">
            <vs-collapse>
              <vs-collapse-item >
                <div slot="header" class="aisea-text-16-400-white mb-4" id="filter-sidebar-vessel-header" >船舶</div>
                <div class="filter-sidebar-font-color filter-sidebar-list-by-category" >
                  <vs-row vs-type="flex" class="mt-1 my-3">
                    <vs-col vs-order="1" vs-type="flex" vs-justify="start" vs-align="center" vs-w="10">
                      <span >すべて</span>
                    </vs-col>
                    <vs-col vs-order="2" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                      <vs-switch color="#48a0f4" v-model="switchVesselAll" />
                    </vs-col>
                  </vs-row>

                  <vs-divider class="filter-sidebar-divide-color" style="opacity: 0.4;" />
                  <ul>
                    <li
                      v-for="vessel in vesselsName"
                      :key="vessel.id"
                      class="mb-3 flex items-center justify-between"
                    >
                      <vs-checkbox
                        v-model="filter.vesselIds"
                        :vs-value="vessel.id"
                        :disabled="vesselIdsCheckboxDisabled"
                        class="ml-0"
                        color="#48a0f4" 
                        >{{ vesselName(vessel) }}</vs-checkbox
                      >
                    </li>
                  </ul>
                </div>
              </vs-collapse-item>
            </vs-collapse>

            <vs-divider class="filter-sidebar-divide-color" />
          </div>

          <vs-collapse>
            <vs-collapse-item >
              <div slot="header" class="aisea-text-16-400-white mb-4" id="filter-sidebar-other-header" >その他</div>
              <div class="filter-sidebar-font-color filter-sidebar-list-by-category" >
                <vs-row vs-type="flex" class="mt-1 my-3">
                  <vs-col vs-order="1" vs-type="flex" vs-justify="start" vs-align="center" vs-w="10">
                    <span >すべて</span>
                  </vs-col>
                  <vs-col vs-order="2" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                    <vs-switch color="#48a0f4" v-model="switchOtherAll" />
                  </vs-col>
                </vs-row>

              </div>
            </vs-collapse-item>
          </vs-collapse>

          <div class="mt-8">
            <vs-button class="filter-action-button" color="#48a0f4" @click="onResetFilter" 
              >リセット</vs-button
            >
            <vs-button class="filter-action-button" color="#48a0f4" @click="updateFilterCondition" :disabled="filter.category < 0 || ( filter.category === 1 && filter.vesselIds.length === 0 )" 
              >決定</vs-button
            >
          </div>
        </div>
      </vs-sidebar>
    </div>

    <fixed-point-cameras-layer
      ref="fixedPointCamerasLayer"
      :map="map"
      :mapEvent="mapEvent"
    />
    <vessel-map-layer
      ref="vesselMapLayer"
      :map="map"
      :mapEvent="mapEvent"
    />


  </div>
</template>

<script>
import Vue from "vue";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import Mapbox from "mapbox-gl";
import _ from "lodash";
import { CAMERA_CATEGORY } from "@/config/const";
import { db } from "@/firebase/firebaseConfig";
import * as MapVesselUtil from "@/utils/MapVesselUtil";
import {MapSource} from "@/config/Map.js";
import VesselMapLayer from "../../../live-map/layers/VesselMapLayer";
import FixedPointCamerasLayer from "../../../live-map/layers/FixedPointCamerasLayer";
import { ColorMixin, DeviceInfoMixin, } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "enterpriseCameraList"
);
const { mapActions: mapActionsOfLiveMap, } = createNamespacedHelpers("liveMap");
// mixins
import {
  StoreMonitoringVesselManeuveringMixin,
} from "@/mixins/addon/secure-dataflow";


export default {
  components: {
    VesselMapLayer,
    FixedPointCamerasLayer,
    LiveCameraGridView: () => import("./components/CameraGridView.vue"),
  },
  mixins: [
    StoreMonitoringVesselManeuveringMixin,
    ColorMixin,
    DeviceInfoMixin,
  ],
  data() {
    return {
      filter: {
        category: 0,
        vesselIds: [],
        sortOrderName: "ASC",
      },
      sortOrderName: "ASC",
      allVesselIds: [],
      vesselIdsCheckboxDisabled: false,
      // categoriesSelected: 0,
      categories: [
        { id: CAMERA_CATEGORY.ALL, label: "すべて", isSelected: true },
        { id: CAMERA_CATEGORY.VESSEL, label: "船舶", isSelected: false },
        { id: CAMERA_CATEGORY.OTHERS, label: "その他", isSelected: false }
      ],
      isFilterSidebarActive: false,
      isFilterSidebarInitialized: false,
      clickNotClose: true,
      gridLayout: 3,
      gridColNum: 2,
      gridWidth: '',
      gridHeight: '',
      map: null,
      pos: null,
      mapRotateDeg: 0,
      closeUpCamera: null,
      firestoreVesselPositionMap: {},
      firestoreUnsubscribes: [],

      switchVesselAll: true,
      switchOtherAll: true,

      origFilter: {
        category: 0,
        vesselIds: [],
        sortOrderName: "",
      },
      origSwitchVesselAll: true,
      origSwitchOtherAll: true,

      iconGridPathMap: {
        iconGrid1: require("@/assets/images/icons/cameras/grid_1.svg"),
        iconGrid2: require("@/assets/images/icons/cameras/grid_2.svg"),
        iconGrid3: require("@/assets/images/icons/cameras/grid_3.svg"),
      },

      iconGridLayout14: require("@/assets/images/icons/cameras/grid_layout_1_4.svg"),
      iconGridLayout13: require("@/assets/images/icons/cameras/grid_layout_1_3.svg"),
      iconGridLayout12: require("@/assets/images/icons/cameras/grid_layout_1_2.svg"),
      iconGridLayout23: require("@/assets/images/icons/cameras/grid_layout_2_3.svg"),
      iconGridLayout22: require("@/assets/images/icons/cameras/grid_layout_2_2.svg"),
      iconGridLayout21: require("@/assets/images/icons/cameras/grid_layout_2_1.svg"),
      iconGridLayout33: require("@/assets/images/icons/cameras/grid_layout_3_3.svg"),
      iconGridLayout32: require("@/assets/images/icons/cameras/grid_layout_3_2.svg"),
      vesselColors: ['pink', 'skyblue', 'yellow', 'palegreen'],
      isStyleReady: false,
      mapEvent: null,
      vesselInfoMap:{},
      pulsing: null,
      fixedPointCameraMap: {},
      fixedPointCamerasSourceId: "fixedPointCamerasSource",
      fixedPointCamerasLayerId: "fixedPointCamerasLayer",
      fixedPointCamerasTextLayerId: "fixedPointCamerasTextLayer",
      fixedPointCamerasPulsingImageId: "fixedPointCamerasPulsingImageId",
      fixedPointCamerasPulsingLayerId: "fixedPointCamerasPulsingLayerId",
      layersMinZoomOfFixedPointCameras: 4,
      vesselCamerasPulsingImageId: "vesselCamerasPulsingImageId",
      closeUpCameraForcePlayFlg: false,
      prevRoute: null,

      intervalIdList: [],

    };
  },
  computed: {
    ...mapState({
      noCameras: state => state.noCameras,
      vessels: state => state.vessels,
      vesselsName: state => state.vesselsName,
      cameras: state => state.cameras
    }),
    dispCameras() {
      let dispCameras = this.cameras.map(camera => {
        let dispCamera = JSON.parse(JSON.stringify(camera));
        const vesselColorIndex = this.allVesselIds.findIndex(x => x === dispCamera.vesselId ) % this.vesselColors.length;
        const vesselColor = this.vesselColors[ vesselColorIndex >= 0 ? vesselColorIndex : this.vesselColors.length - 1 ];
        const vessel = this.vesselsName.find( x => x.id === dispCamera.vesselId );
        dispCamera.vesselColor = vesselColor;

        const isFixedPointCamera = Object.keys(this.fixedPointCameraMap).includes(dispCamera.id);
        dispCamera.vesselCapitalLetter = isFixedPointCamera ? 'FIXED' : vessel ? vessel.name.charAt(0): ' ';

        return dispCamera;
      });

      return dispCameras;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
  },
  watch: {
    gridLayout() {
      this.$nextTick(() => {
        this.map.jumpTo({
          center: this.pos.center,
        });
        this.map.resize();

        if (this.gridLayout === 3 ) {
          FireStoreService.getAccountSetting('camera_list').then(cameraListSettings => {
            if ( cameraListSettings ) {
              this.setCloseUpCamera(cameraListSettings['close_up_camera_id']); 
            }
          });
        } else {
          this.setCloseUpCamera(null); 
          this.mirroringVideo(false);
        }

      });
      FireStoreService.setAccountSetting('camera_list', { grid_layout: this.gridLayout });
    },
    gridColNum() {
      FireStoreService.setAccountSetting('camera_list', { grid_col_num: this.gridColNum });
    },
    isFilterSidebarActive() {
      if ( this.isFilterSidebarActive ) {
        this.backupFilterValue();
        if (!this.isFilterSidebarInitialized) {
          setTimeout(() => {
            this.onClickCollapse();
          }, 500);
          this.isFilterSidebarInitialized = true;
        }
      }
    },
    switchVesselAll() {
      // フィルタで全ての船舶所属カメラを選択
      this.categories.forEach(category => {
        category.isSelected = false;
      });
      this.vesselIdsCheckboxDisabled = !this.switchVesselAll;
      if ( this.switchVesselAll ) {
        if ( this.switchOtherAll ) {
          this.categories.find(x => x.id === CAMERA_CATEGORY.ALL).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.ALL;
        } else {
          this.categories.find(x => x.id === CAMERA_CATEGORY.VESSEL).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.VESSEL;
        }
      } else {
        if ( this.switchOtherAll ) {
          this.categories.find(x => x.id === CAMERA_CATEGORY.OTHERS).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.OTHERS;
        } else {
          this.filter.category = -1;
        }
      }
    },
    switchOtherAll() {
      // フィルタで全てのその他カメラを選択
      this.categories.forEach(category => {
        category.isSelected = false;
      });
      if ( this.switchOtherAll ) {
        if ( this.switchVesselAll ) {
          this.categories.find(x => x.id === CAMERA_CATEGORY.ALL).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.ALL;
        } else {
          this.categories.find(x => x.id === CAMERA_CATEGORY.OTHERS).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.OTHERS;
        }
      } else {
        if ( this.switchVesselAll ) {
          this.categories.find(x => x.id === CAMERA_CATEGORY.VESSEL).isSelected === true;
          this.filter.category = CAMERA_CATEGORY.VESSEL;
        } else {
          this.filter.category = -1;
        }
      }
    },
    onChangeWindowSize() {
      this.mirroringVideo();
    },
    verticalNavMenuWidth() {
      setTimeout(() => {
        this.mirroringVideo();
      }, 1200);
    },
  },
  methods: {
    ...mapActions(["fetchCameras", "filterCamera", "resetCameraListState"]),
    ...mapActionsOfLiveMap(["fetchFixedPointCameras"]),

    gridLayoutStyle(blockName) {
      // レイヤー分割の指定

      const leftBlockWidth      = '35%';
      const gridAreaHeight      =  '100vh - 60px';
      const closeUpCameraHeight = '( 50vh - 60px - 32px )';

      if ( blockName === 'leftBlock' ) {
        return { 
          display: this.gridLayout !== 1 ? 'block' : 'none',
          width:   this.gridLayout !== 1 ? leftBlockWidth : '0',
          padding: '0',
        };

      } else if ( blockName === 'rightBlock' ) {
        return { 
          width: this.gridLayout !== 1 ? `calc(100% - ${leftBlockWidth})` : '100%',
        };

      } else if ( blockName === 'mapBlock' ) {
        return {
          height: `calc( ${gridAreaHeight} )`,
        };
      } else if ( blockName === 'closeUpCameraBlock' ) {
        return { 
          display: this.gridLayout === 3 ? 'block' : 'none',
          height:  `calc( ${closeUpCameraHeight} - 8px )`,
        };
      } else if ( blockName === 'cameraListBlock' ) {
        return {
          height:  this.gridLayout === 3 ? `calc( ${gridAreaHeight} - ${closeUpCameraHeight} )` : `calc( ${gridAreaHeight} )`,
          margin: 0,
          'overflow-y': 'auto', 
        };
      }
      return {};
    },

    async loadMapbox() {
      
      this.pos = await LocalDbService.getDefaultPosition();
      const mapStyleLocal = await LocalDbService.getMapStyle();
      Mapbox.accessToken = process.env.VUE_APP_MAPBOX_TOKEN;
      Mapbox.prewarm();
      Mapbox.maxParallelImageRequests = 10;
      this.map = new Mapbox.Map({
        container: "map-on-camera-list",
        style: mapStyleLocal,
        center: this.pos.center,
        zoom: 4,
        doubleClickZoom: false,
        maxZoom: 18,
        attributionControl: false,
        localIdeographFontFamily: "'Noto Sans', sans-serif"
      });
      this.map.on('rotate', () => {
        this.mapRotateDeg = this.map.getBearing() * -1;
      });      

      this.map.on("style.load", async () => {
        await this.setupMapSources();

        this.$nextTick(async () => {

          this.createPulsingAnimation(this.map);
          this.addPulsingAnimationLayer();

          this.$refs.vesselMapLayer.initialized = true;
          this.$refs.vesselMapLayer.isMapReady();

          // 固定カメラの初期化
          this.$refs.fixedPointCamerasLayer.createPulsing(this.map);
          await this.$refs.fixedPointCamerasLayer.setMapSource();
          this.setMapLayerOfFixedPointCameras();
          this.isStyleReady = true;
        });

      });
      const self = this;
      this.map.on('dblclick', () => {
        self.initMapPosition();
      });

    },

    createPulsingAnimation(map) {
      // パルスアニメーションオブジェクト生成
      let size = 150; // 円の大きさ
      let self = this;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          const duration          = 4000; // パルス１周期の時間(ms)
          const outerInnerRate    =  0.3; // パルスの開始円周と終了円周との比率
          const increaseSpeedRate =  0.5; // パルスの拡大スピード
          let t = (performance.now() % duration) / duration;

          let innerRadius = (size / 2) * outerInnerRate;
          let outerRadius = innerRadius + (size / 2) * (1 - outerInnerRate) * t * increaseSpeedRate;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          self.mapTriggerRepaint(map);

          return true;
        }
      };
    },
    mapTriggerRepaint: _.debounce((map) => {
      // map.triggerRepaint() は負荷が大きいので、ある程度まとめてから処理実行。
      map.triggerRepaint();
    }, 200),

    addPulsingAnimationLayer() {
      // パルスアニメーション表示
      this.map.addImage(this.vesselCamerasPulsingImageId, this.pulsing, {pixelRatio: 2});

      this.map.addLayer({
        id: MapSource.OwnVesselPointSource.id,
        type: "symbol",
        source: MapSource.OwnVesselPointSource.id,
        maxzoom: 20,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": this.vesselCamerasPulsingImageId
        }
      });
    },

    mapZoomIn() {
      this.map.zoomTo(this.map.getZoom() + 1);
    },
    mapZoomOut() {
      this.map.zoomTo(this.map.getZoom() - 1);
    },
    mapNorthUp() {
      this.map.flyTo({ bearing: 0, });
      this.mapRotateDeg = 0;
    },

    setMapLayerOfFixedPointCameras() {
      // 固定カメラのレイヤー

      this.map.addImage(this.fixedPointCamerasPulsingImageId, this.pulsing, { pixelRatio: 2 });
      this.map.addLayer({
        id: this.fixedPointCamerasPulsingLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": this.fixedPointCamerasPulsingImageId,
        }
      });

      this.map.addLayer({
        id: this.fixedPointCamerasLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image":  "{icon}",
          "icon-rotate": {
            type: "identity",
            property: "direction"
          },
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1
        }
      });

      this.map.addLayer({
        id: this.fixedPointCamerasTextLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          // "text-allow-overlap": true,
          "text-field": "{name}",
          "text-size": 12,
          "text-offset": [
            "case",
            ["boolean", ['get', 'isTextTop'], true],
            ["literal", [0, -2]],
            ["literal", [0, 2]]
          ]
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1
        }
      });

    },

    onSelectCamera(cameraId) {
      this.closeUpCameraForcePlayFlg = true;
      this.setCloseUpCamera(cameraId);
      this.jumpToCameraPosition(cameraId);
    },

    setCloseUpCamera(cameraId) {
      this.closeUpCamera = null;

      this.$nextTick(() => {
        if ( cameraId && this.dispCameras.find(x => x.id === cameraId)) {
          this.closeUpCamera = JSON.parse(JSON.stringify(this.dispCameras.find(x => x.id === cameraId)));
          FireStoreService.setAccountSetting('camera_list', { close_up_camera_id: cameraId });
          this.mirroringVideo(true);
        }
      });
    },

    jumpToCameraPosition(cameraId){

      let centerLngLat = [];
      let zoom = 11;
      const vesselId = this.cameras.find(camera => camera.id === cameraId).vesselId;
      if ( vesselId && this.firestoreVesselPositionMap[vesselId] ) {
        const vesselPosition = this.firestoreVesselPositionMap[vesselId];
        const vesselInfo = this.vesselInfoMap[vesselId];
        centerLngLat = [vesselPosition.l._long, vesselPosition.l._lat];
        if ( vesselInfo && vesselInfo.operationMode ) {
          zoom = this.getZoomLevelByOperationMode(vesselInfo.operationMode);
        }
      } else if ( Object.keys(this.fixedPointCameraMap).includes(cameraId) ) {        
        const fixedPointCameraFeature = this.fixedPointCameraMap[cameraId];
        centerLngLat = fixedPointCameraFeature.geometry.coordinates;
      }

      if ( centerLngLat.length === 2 ) {
        this.map.jumpTo({
          center: centerLngLat,
          zoom: zoom,
        });
      }
    },

    resetMapPosition() {
      this.map.flyTo({
        center: this.pos.center,
        zoom: this.pos.zoom,
        speed: 5,
      });
    },
    initMapPosition() {
      this.map.flyTo({
        center: this.pos.center,
        zoom: 4,
        speed: 5,
      });
    },

    reconnectFirestore: _.debounce((self) => {
      self.firestoreUnsubscribes.forEach(unsubscribe => unsubscribe());
      self.$nextTick(() => {
        setTimeout(() => {
          self.subscribeVesselPosition(self.allVesselIds, 0);
        }, 1000);
      });
    }, 1000),

    async subscribeVesselPosition(vesselIds, retryCount) {
      // map上の船舶アイコンの subscribe

      vesselIds.forEach(vesselId => {
        db.collection("vessel_info")
          .doc(vesselId)
          .get()
          .then(value => {
            if ( value.exists ) {
              let info = value.data();
              this.vesselInfoMap[vesselId] = info;

              this.firestoreUnsubscribes.push(db
                .collection("vessel_position")
                .doc(vesselId)
                .onSnapshot(docSnapshot => {
                  let v = docSnapshot.data();
                  if ( v && this.checkSubscribeValidation() ) {
                    Vue.$log.debug("### vessel onSnapshot ", vesselId, v);
                    Vue.set(this.firestoreVesselPositionMap, vesselId, v);
                    if ( this.map && this.isStyleReady ) {
                      this.updateMapSourceData();
                    }
                  }
                }));
            } else {
              retryCount = retryCount || 0;
              if ( retryCount < 10 ) {
                setTimeout(() => {
                  Vue.$log.debug("### vessel_info not exists. retry = ", vesselId, retryCount);
                  this.subscribeVesselPosition([ vesselId ], retryCount + 1);
                }, 1000) 
              }
            }
         });
      });
    },
    checkSubscribeValidation() {
      if ( this.$route.name !== "enterprise-management-camera-list" ) {
        // beforeDestroy() で削除しきれなかったsnapshot処理を検知したら、終了処理をコール。
        Vue.$log.debug(`remained subscribe process has detected. So, destroy. this.$route.name = `, this.$route.name);
        this.cleanup();
        return false;
      }
      return true;
    },

    updateMapSourceData() {
      // mapSourceの更新

      let featureForPointList = [];
      let featureForVectorList = [];
      let featureForPolygonSetList = [];

      Object.entries(this.firestoreVesselPositionMap).forEach(([vesselId, v]) => {
        const info = this.vesselInfoMap[vesselId];
        let currentEpochSeconds = (v.t / 1000); // 暫定で常に最新扱い
                                  // moment.utc().unix();

        let feature = MapVesselUtil.createPointFeature(
          vesselId,
          v,
          info,
          currentEpochSeconds,
          false,
          true, // 自社船指定（マーカー表示）
        );

        let featureForVector = MapVesselUtil.createVectorFeature(
          vesselId,
          v,
          info,
          5
        );

        let featureForPolygonSet = MapVesselUtil.createPolygonFeature(
          vesselId,
          v,
          info
        );
        
        featureForPointList.push(feature);
        featureForVectorList = featureForVectorList.concat(featureForVector);
        featureForPolygonSetList = featureForPolygonSetList.concat(featureForPolygonSet);
      });

 
      this.map.getSource(MapSource.OwnVesselPointSource.id).setData({
        type: "FeatureCollection",
        features: featureForPointList
      });

      this.map.getSource(MapSource.OwnVesselMarkerSource.id).setData({
        type: "FeatureCollection",
        features: featureForPointList
      });

      this.map.getSource(MapSource.OwnVesselVectorSource.id).setData({
        type: "Feature",
        features: featureForVectorList
      });

      this.map.getSource(MapSource.OwnVesselPolygonSource.id).setData({
        type: "FeatureCollection",
        features: featureForPolygonSetList
      });
    },


    async setupMapSources() {
      // mapSourceの初期化

      this.map.addSource(MapSource.VesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.VesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.VesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.VesselWakeLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.VesselWakeLineSourceForClickEvent.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      /*=========================================================================================
         自社船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.OwnVesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.OwnVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.OwnVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.OwnVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      /*=========================================================================================
         選択船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.SelectedVesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.SelectedVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.SelectedVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      this.map.addSource(MapSource.SelectedVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

    },    

    vesselName(vessel) {
      return vessel.name_ja || vessel.name;
    },

    setGridSize(gridLayout, gridColNum) {
      this.gridLayout = gridLayout;
      this.gridColNum = gridColNum;

      this.gridWidth = 
          gridLayout === 1 && gridColNum === 4 ? 'calc( ( 100% / 4 - 8px ) )'
        : gridLayout === 1 && gridColNum === 3 ? 'calc( ( 100% / 3 - 8px ) )'
        : gridLayout === 1 && gridColNum === 2 ? 'calc( ( 100% / 2 - 8px ) )'
        : gridLayout === 2 && gridColNum === 3 ? 'calc( ( 100% / 3 - 8px ) )'
        : gridLayout === 2 && gridColNum === 2 ? 'calc( ( 100% / 2 - 8px ) )'
        : gridLayout === 2 && gridColNum === 1 ? 'calc( ( 100% / 1 - 8px ) )'
        : gridLayout === 3 && gridColNum === 3 ? 'calc( ( 100% / 3 - 8px ) )'
        : gridLayout === 3 && gridColNum === 2 ? 'calc( ( 100% / 2 - 8px ) )'
        : 'calc( ( 100% - 8px ) )'
      ;

      this.gridHeight = 
          gridLayout === 1 && gridColNum === 4 ? 'calc( ( 100vh - 60px ) / 4 -  6px )'
        : gridLayout === 1 && gridColNum === 3 ? 'calc( ( 100vh - 60px ) / 3 -  6px )'
        : gridLayout === 1 && gridColNum === 2 ? 'calc( ( 100vh - 60px ) / 2 -  6px )'
        : gridLayout === 2 && gridColNum === 3 ? 'calc( ( 100vh - 60px ) / 4 -  6px )'
        : gridLayout === 2 && gridColNum === 2 ? 'calc( ( 100vh - 60px ) / 3 -  6px )'
        : gridLayout === 2 && gridColNum === 1 ? 'calc( ( 100vh - 60px ) / 2 -  6px )'
        : gridLayout === 3 && gridColNum === 3 ? 'calc( ( ( 100vh - (' + this.gridLayoutStyle('closeUpCameraBlock').height + ') ) / 2 - 38px ) )'
        : gridLayout === 3 && gridColNum === 2 ? 'calc( ( ( 100vh - (' + this.gridLayoutStyle('closeUpCameraBlock').height + ') ) / 2 - 38px ) )'
        : 'calc( ( 100vh - 75px ) )'
      ;

    },

    mirroringVideo(mirroringVideoOn){
      if (mirroringVideoOn) {
        this.$vs.loading({container: "#close-up-camera-area",});
        setTimeout(() => {

          const ccId = `grid-view-live-camera-${this.closeUpCamera.id}`;
          var video = document.getElementById(ccId).querySelector('video');
          const videoRect = video.getBoundingClientRect();

          let closeUpCameraHeight = 250;
          if ( this.$refs.closeUpCameraGrid ) {
            closeUpCameraHeight = this.$refs.closeUpCameraGrid.$el.getBoundingClientRect().height - this.$refs.closeUpCameraGrid.cameraInfoBarHeight;
          }

          const scaleRateHeight = closeUpCameraHeight / videoRect.height;
          const scaleRateWidth =  [4   ].includes(this.closeUpCamera.movieType) ? scaleRateHeight * ( ( 4 / 3 ) / ( 16 / 9 ) ) 
                                : [2, 5].includes(this.closeUpCamera.movieType) ? scaleRateHeight * ( ( 4 / 3 ) / ( 16 / 9 ) ) 
                                : scaleRateHeight * ( ( 4 / 3 ) / ( 16 / 9 ) );

          var canvas = document.getElementById("close-up-canvas");
          canvas.getContext("2d").scale(scaleRateWidth, scaleRateHeight);
          canvas.width = videoRect.width * scaleRateWidth;
          canvas.height = videoRect.height * scaleRateHeight;
          
          const fps = 29.97;  // DVDレベル
          const intervalId = setInterval(() => {
            canvas.getContext("2d").drawImage(video, 0, 0, videoRect.width * scaleRateWidth, videoRect.height * scaleRateHeight);
          }, ( 1000 / fps ) );
          this.intervalIdList.push(intervalId);

          this.$nextTick(() => {
            this.$vs.loading.close("#close-up-camera-area > .con-vs-loading");
          });
          
        }, 2000); // クローズアップカメラ領域の描画完了まで待つ canvasタグを捕まえるため。
      } else {
        this.intervalIdList.forEach(intervalId => clearInterval(intervalId));
      }
    },

    backupFilterValue() {
      // リセット用に現在のフィルタ値をバックアップ
      this.origSwitchVesselAll = this.switchVesselAll;
      this.origSwitchOtherAll = this.switchOtherAll;
      this.origFilter = _.cloneDeep(this.filter);
    },

    updateFilterCondition() {
      // フィルタの決定ボタン
      this.filter.sortOrderName = this.sortOrderName;
      this.filterCamera(this.filter);
      this.isFilterSidebarActive = false;
    },

    async onResetFilter() {
      this.switchVesselAll = this.origSwitchVesselAll;
      this.switchOtherAll  = this.origSwitchOtherAll;
      this.filter = _.cloneDeep(this.origFilter);
    },

    onClickCollapse() {
      document.getElementById('filter-sidebar-vessel-header').click();
      document.getElementById('filter-sidebar-other-header').click();
    },


    fetchSvgIcons () {
      [
        "iconGrid1",
        "iconGrid2",
        "iconGrid3",
      ].forEach(async itemIcon => {
        const svgText = await fetch(this.iconGridPathMap[itemIcon])
          .then(response => {
            return response.text();
          });
        const divElement = document.getElementById(`grid-button-${itemIcon}`);
        if ( divElement ) {
          divElement.innerHTML = svgText;
        }
      });
    },

    cleanup() {
      this.resetCameraListState();
      this.firestoreUnsubscribes.forEach(unsubscribe => unsubscribe());

      this.map = null;
      let mapElement = document.getElementById('map-on-camera-parent');
      if ( mapElement ) {
        //親要素内の子要素を削除
        mapElement.innerHTML = '';
      }

    },
  },
  created() {
    this.map = null;
    this.setGridSize(this.gridLayout, this.gridColNum);
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "0.8rem 0 0 0.8rem";
    let routerHeaderElement = document.getElementsByClassName("router-header");
    routerHeaderElement[0].style['margin-bottom'] = "0.2rem";

    this.fetchSvgIcons();

    this.allVesselIds = await this.fetchCameras();
    this.filter.vesselIds = this.allVesselIds;

    this.subscribeVesselPosition(this.allVesselIds);

    const prevRouteName = (this.prevRoute && this.prevRoute.name) ?  this.prevRoute.name : '';
    FireStoreService.getAccountSetting('camera_list').then(cameraListSettings => {
      if ( cameraListSettings ) {
        if (prevRouteName.startsWith("enterprise-management-camera-")) {
          this.gridLayout = cameraListSettings['grid_layout'] || this.gridLayout;
          this.gridColNum = cameraListSettings['grid_col_num'] || this.gridColNum;
        } else {
          this.gridLayout = 3;
          this.gridColNum = 2;
          FireStoreService.setAccountSetting('camera_list', { grid_layout: this.gridLayout, grid_col_num: this.gridColNum });
        }
        if ( this.gridLayout === 3 ) {
          this.setCloseUpCamera(cameraListSettings['close_up_camera_id']);
        }
      }
      this.setGridSize(this.gridLayout, this.gridColNum);
    });

    const fixedPointCameraFeatures = await this.fetchFixedPointCameras();
    if ( fixedPointCameraFeatures.features ) {
      fixedPointCameraFeatures.features.map(camera => {
        Vue.set(this.fixedPointCameraMap, camera.properties.cameraId, camera);
      });      
    }

    this.loadMapbox();
  },
  updated() {
    // ページに何かしらの変化があれば、onSnapshotを再接続。( 過度にならないように debounceをかけておく)
    this.reconnectFirestore(this);
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
        vm.prevRoute = from;
    })
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#enterprise-camera-list {


  .mapboxgl-canvas {
    border-radius: 8px;
    width: 100% !important;
  }

  .sort-button {
    margin: 0 1rem 0 0;
    width: 30px;
    border: 2px solid #48A0F4;
    height: 30px;
    border-radius: 4px;
    cursor: pointer;

    .sort-icon {
      color: #48A0F4;
    }
  }
  .filter-button {
    margin: 0px 1rem;
    width: 30px;
    border: 2px solid #48A0F4;
    height: 30px;
    border-radius: 4px;

    .filter-icon {
      color: #48A0F4;
    }
  }
  .filter-action-button {
    width: 46%;
    margin: 0.2rem; 
    padding: 0.6rem;
    font-size: smaller;
  }
  .filter-sidebar-font-color {
    color: #c2c6ca; 
  }
  .filter-sidebar-divide-color {
    background-color: #c2c6ca; 
  }
  .filter-sidebar-background {
    background-color: #2d3240;
  }
  .filter-sidebar-list-by-category {
    background-color: #3f4655; 
    padding: 0.6rem 1rem;
    border-radius: 0.4rem;
  }
  .grid-button {
    height: 2rem;
    margin: 0.0rem;
    border: 1px solid #48A0F4;
    cursor: pointer;
  }

  .grid-button-icon {  
    height: 24px;
    min-width: 30px;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .grid-button-selected {
    background-color: #49a0f4;
    svg {
      path {
        stroke: $aisea-white;
      }
    }
    &:hover {
      background-color: #c9e3fc;
      svg {
        path {
          stroke: #49a0f4;
        }
      }
    }
  }
  .grid-button-unselected {
    &:hover {
      background-color: #c9e3fc;
    }
  }
  #close-up-camera-area {    
    margin: 0 0 8px 8px;
    background-color: silver;
    border-radius: 8px;
  }

  .vs-collapse {
    padding: 0;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
      color: $aisea-white;
    }
  }

  .con-content--item {
    padding: 0;
  }

}
.camera-list-layout-dropdown {
  padding-top: 10px;
  z-index: 99999;
  a {
    padding: 0;
  }
  .camera-list-layout-dropdown-item {
    height: 1.4rem;
    padding: 1.0rem 1.0rem;
    margin: 0;
    border-radius: 0.4rem;
    &:hover {
      background-color: #56CCF240;
    }
  }
  .vs-dropdown--item {
    margin:0;
    min-width: fit-content;
  }
  .vs-dropdown--menu--after {
    background-color: rgba(255, 255, 255, 0);
    border: none;
  }
}
</style>
